// src/lib/avatars.js
//
// Default avatar generation — DiceBear "dylan" (bold illustrated faces),
// deterministic per seed. ONE place defines the platform's default-avatar
// style; components must use these helpers instead of hardcoding DiceBear
// URLs, so a future style change is a one-line edit here.
//
// Usage:
//   dylanUrl(seed)               → avatar URL for any stable seed
//   defaultAvatarFor(entity)     → fallback for anything with a username/wallet
//   randomAvatarSeed()           → for "shuffle" interactions

const DICEBEAR_BASE = 'https://api.dicebear.com/10.x/dylan/svg';

/** Deterministic Dylan avatar for a seed (username, wallet, id...). */
export function dylanUrl(seed) {
  const safe = encodeURIComponent(String(seed || 'lunexx'));
  return `${DICEBEAR_BASE}?seed=${safe}`;
}

/** @deprecated Use dylanUrl. Kept temporarily for import compatibility. */
export const croodlesUrl = dylanUrl;

/**
 * Fallback avatar for display: stored avatar wins, otherwise a
 * deterministic Dylan avatar from the most stable identifier available.
 *   resolveAvatar(req.avatarUrl, req.requesterWallet)
 */
export function resolveAvatar(avatarUrl, seed) {
  return avatarUrl || dylanUrl(seed);
}

/** Random seed for shuffle/re-roll UIs. */
export function randomAvatarSeed() {
  return crypto.randomUUID().slice(0, 8);
}

/**
 * True if a stored avatar_url is one of OUR generated DiceBear defaults
 * rather than a real uploaded photo. Used by onboarding/profile UIs to
 * decide whether re-rolling/replacing is offered. Matches any dicebear
 * URL so a future style change doesn't strand old defaults as "real".
 */
export function isDefaultAvatar(avatarUrl) {
  return typeof avatarUrl === 'string' && avatarUrl.includes('api.dicebear.com');
}

export default dylanUrl;
